import { HttpClient } from 'api/helpers/HttpClient';

export const getPurchaseNodeId = params => {
  const { url, hasClaroAdActive, ...restParams } = params;
  console.log('url', url)
  const apiCall = new HttpClient({ hasClaroAdActive: hasClaroAdActive });
  return apiCall
    .get(url, {
      ...restParams,
    })
    .then(res =>res)
    .catch(error => {
      throw error
    });
};
